import { declineWord } from "@packages/frontend-helpers";
import { i18n } from "@/boot/i18n";
import { API } from "@/boot/api";

const state = {
  claims: [],
  historyClaims: [],
  clients: null,
  ageOfClients: null,
};

const getters = {};

const mutations = {
  SET_CLAIMS: (state, claims) => {
    state.claims = claims;
  },

  SET_DATA_FOR_GRAF: (state, claims) => {
    if (claims.length === 1) {
      state.clients = claims;
      state.clients.unshift({ age: 18 });
      state.clients.push({ age: 100 });
      state.clients.push({
        customer_count: state.clients[1].customer_count * 2,
      });
    } else {
      state.clients = claims;
    }
  },

  SET_CLIENT_AGE: (state, claims) => {
    if (claims.length === 1) {
      state.ageOfClients = claims;
      state.ageOfClients.unshift(18);
      state.ageOfClients.push(100);
    } else {
      state.ageOfClients = claims;
    }
    state.ageOfClients = state.ageOfClients.map(
      (c) =>
        `${c} ${declineWord(
          c,
          ...i18n.global.tm("declinationHelperWords.years")
        )}`
    );
  },
};

const actions = {
  claims({ commit }, data) {
    return new Promise((resolve, reject) => {
      API.get(`account/${data.id}/claims`, {
        params: {
          type: data.type,
          page: data.page,
          select_all: data.select_all,
          point_id: data.point_id,
          date_start: data.date_start,
          date_finish: data.date_finish,
        },
      })
        .then((response) => {
          commit("SET_CLAIMS", response.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  allShopPoints() {
    return new Promise((resolve, reject) => {
      API.get("account/points")
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  clientPortrait({ commit }, data) {
    return new Promise((resolve, reject) => {
      API.get("statistics/client/portrait", {
        params: {
          point_ids: data.point_ids,
        },
      })
        .then((response) => {
          commit(
            "SET_CLIENT_AGE",
            response.data.data.map((d) => d.age)
          );
          commit("SET_DATA_FOR_GRAF", response.data.data);

          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
